export const mixin = {
  data: () => ({
    fieldProps: {
      flat: true,
      solo: true,
      color: "primary",
    },
  }),
};
